// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1M15o","content":"styles_content__NlIeR","tableWrap":"styles_tableWrap__5p4Qz"};